import {notification} from '@/api-services'
import {errorHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'
import {parseLinkHeader, paginationHandler} from '@/utils/common'

export const useNotificationStore = defineStore('notificationStore', {
  state: () => ({
    allNotifications: [],
    lawyerCount: null,
    newNotificationCount: 0,
    allNewNotifications: [],
    markedAsReadNotification: '',
    loading: false,
    error: null,
    links: {},
  }),
  actions: {
    async getNotification() {
      this.loading = true
      try {
        const response = await notification.getNotification()
        const data = response.data
        this.links = parseLinkHeader(response.headers.link)
        this.allNotifications = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getNewNotification() {
      this.loading = true
      try {
        const response = await notification.getNewNotification()
        const data = response.data
        this.allNewNotifications = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getReadNotification() {
      this.loading = true
      try {
        const response = await notification.readNotification()
        const data = response.data
        this.markedAsReadNotification = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getNewLawyerCountNotification() {
      this.loading = true
      try {
        const response = await notification.getNewLawyerCount()
        const data = response.data
        this.lawyerCount = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getNewNotificationCount() {
      this.loading = true
      try {
        const response = await notification.getNewNotificationCount()
        const data = response.data
        this.newNotificationCount = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getNextPage(data) {
      const {value} = data
      try {
        const response = await paginationHandler(this.links.next)
        this.allNotifications = [...value, ...response.data]
        this.links = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      }
    },
  },
})
